// Generated from fixed build58. Run scripts/generate-badge-reference.cjs.
export function shouldSignalBadgeActivity(path, method) {
  if (!method || method === 'GET' || path.startsWith('/me/badges')) return false;
  return (
    [
      '/albums',
      '/tracks',
      '/bookmarks',
      '/likes',
      '/comments',
      '/lists',
      '/me/archive/listened',
    ].some((prefix) => path.startsWith(prefix)) || /^\/users\/\d+\/follow(?:\?|$)/.test(path)
  );
}
export const BADGE_DISCOVERY_EVENTS = new Set([
  'SEARCH_RESULT_OPEN',
  'ALBUM_OPEN',
  'ARTIST_OPEN',
  'REVIEW_OPEN',
  'PLAYLIST_OPEN',
  'USER_OPEN',
  'CONTENT_SHARE',
  'RECOMMENDATION_CLICK',
  'PREVIEW_PLAY',
]);
